import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";
const ThatichetlapalemKalyanamandapam = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  // const images = [
  //   "/images/image27.jpeg",
  //   "/images/image28.jpeg",
  //   "/images/image29.jpeg",
  // ];

  const pricingData = [
    {
      id: 1,
      purpose: "Both 1st floor and 2nd floor",
      rent: 15000,
      deposit: 20000,
      gst: 2700,
      cleaning: 2000,
      total: 19700,
    },
    {
      id: 2,
      purpose: "1st floor / 2nd floor",
      rent: 10000,
      deposit: 20000,
      gst: 1800,
      cleaning: 2000,
      total: 33800,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img src={item.url} alt={`Thatichetlapalem Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>Thatichetlapalem Kalyanamandapam</h1>
                  <p>Versatile Event Venue in Vizag</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Venue Details */}
        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Thatichetlapalem Kalyanamandapam</strong>, located in Vizag,
            offers versatile event spaces suitable for weddings, receptions, and
            private gatherings. Managed by <strong>VMRDA</strong>, it includes
            spacious halls and modern amenities to host a variety of functions.
          </p>

          {/* Amenities Section */}
          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Ground Floor Parking with Office Room (1,974 sqft)</li>
            <li>✅ 1st Floor Kalyanamandapam (1,974 sqft)</li>
            <li>✅ 2nd Floor Dining Hall (1,974 sqft)</li>
            <li>✅ Total Area: 5,922 sqft</li>
            <li>✅ Well-maintained and clean facilities</li>
          </ul>

          {/* Pricing Section */}
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign /> Total:{" "}
                  <strong>{item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Additional Charges */}
          <p className="note">
            <strong>Note:</strong> Electrical charges as consumed will be paid
            by the applicant to VMRDA.
          </p>

          {/* Contact Section */}
          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Thatichetlapalem, Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43211
            </p>
            <p>
              <FaEnvelope /> Email: info@thatichetlapalem.com
            </p>
          </div>

          {/* Book Now Button */}
          <Link to="/booking" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThatichetlapalemKalyanamandapam;
